import * as Dtos from "../dtos/Tmd.dtos";
import { IFormFilter } from "../reducers/index";

export const
    LoadHrec: IHrecLoadActionCreator = () => {
        return {
            type: ACTION_HRECS_LOAD
        }
    },
    LoadHrecById: IHrecLoadByIdActionCreator = (id) => {
        return {
            type: ACTION_HRECS_LOAD_BY_ID,
            id
        }
    },
    LoadSuccess: IHrecLoadSuccessActionCreator = (formData, formState, formProperties, lookups, responseStatus) => {
        return {
            type: ACTION_HRECS_LOAD_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups,
            responseStatus
        }
    },
    LoadFailure: IHrecLoadFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_HRECS_LOAD_FAILURE,
            responseStatus
        }
    },

    SaveHrec: IHrecSaveActionCreator = (formData) => {
        return {
            type: ACTION_HRECS_SAVE,
            formData
        }
    },
    SaveSuccess: IHrecSaveSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_HRECS_SAVE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    SaveFailure: IHrecSaveFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_HRECS_SAVE_FAILURE,
            responseStatus
        }
    },

    CreateHrec: IHrecCreateActionCreator = () => {

        return {
            type: ACTION_HRECS_CREATE
        }
    },
    CreateSuccess: IHrecCreateSuccessActionCreator = (formData, formState, formProperties, lookups) => {
        return {
            type: ACTION_HRECS_CREATE_SUCCESS,
            formData,
            formState,
            formProperties,
            lookups
        }
    },
    CreateFailure: IHrecCreateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_HRECS_CREATE_FAILURE,
            responseStatus
        }
    },

    ValidateHrec: IHrecValidateActionCreator = (formData) => {
        return {
            type: ACTION_HRECS_VALIDATE,
            formData
        }
    },
    ValidateSuccess: IHrecValidateSuccessActionCreator = (formData, formState, responseStatus) => {
        return {
            type: ACTION_HRECS_VALIDATE_SUCCESS,
            formData,
            formState,
            responseStatus
        }
    },
    ValidateFailure: IHrecValidateFailureActionCreator = (responseStatus) => {
        return {
            type: ACTION_HRECS_VALIDATE_FAILURE,
            responseStatus
        }
    },

    Clear: IHrecClearActionCreator = (propertiesToClear?) => {
        return {
            type: ACTION_HRECS_CLEAR,
            propertiesToClear
        }
    },

    Filter: IHrecFilterActionCreator = (formFilter) => {
        return {
            type: ACTION_HRECS_FILTER,
            formFilter
        }
    };



export const
    ACTION_HRECS_LOAD = "ACTION_HRECS_LOAD",
    ACTION_HRECS_LOAD_BY_ID = "ACTION_HRECS_LOAD_BY_ID",
    ACTION_HRECS_LOAD_SUCCESS = "ACTION_HRECS_LOAD_SUCCESS",
    ACTION_HRECS_LOAD_FAILURE = "ACTION_HRECS_LOAD_FAILURE",

    ACTION_HRECS_SAVE = "ACTION_HRECS_SAVE",
    ACTION_HRECS_SAVE_SUCCESS = "ACTION_HRECS_SAVE_SUCCESS",
    ACTION_HRECS_SAVE_FAILURE = "ACTION_HRECS_SAVE_FAILURE",

    ACTION_HRECS_CREATE = "ACTION_HRECS_CREATE",
    ACTION_HRECS_CREATE_SUCCESS = "ACTION_HRECS_CREATE_SUCCESS",
    ACTION_HRECS_CREATE_FAILURE = "ACTION_HRECS_CREATE_FAILURE",

    ACTION_HRECS_VALIDATE = "ACTION_HRECS_VALIDATE",
    ACTION_HRECS_VALIDATE_SUCCESS = "ACTION_HRECS_VALIDATE_SUCCESS",
    ACTION_HRECS_VALIDATE_FAILURE = "ACTION_HRECS_VALIDATE_FAILURE",

    ACTION_HRECS_CLEAR = "ACTION_HRECS_CLEAR",

    ACTION_HRECS_FILTER = "ACTION_HRECS_FILTER";

export interface IHrecLoadAction {
    type: "ACTION_HRECS_LOAD";
}

export interface IHrecLoadActionCreator {
    (): IHrecLoadAction;
}

export interface IHrecLoadSuccessAction {
    type: "ACTION_HRECS_LOAD_SUCCESS";
    formData: Dtos.Hrec | Dtos.Hrec[];
    formState: Dtos.FormState;
    formProperties: Dtos.FormProperty[];
    lookups: Dtos.Lookup[];
    responseStatus: Dtos.ResponseStatus;
}

export interface IHrecLoadSuccessActionCreator {
    (
        formData: Dtos.Hrec | Dtos.Hrec[],
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[],
        responseStatus: Dtos.ResponseStatus
    ): IHrecLoadSuccessAction;
}

export interface IHrecLoadFailureAction {
    type: "ACTION_HRECS_LOAD_FAILURE";
    responseStatus: Dtos.ResponseStatus;
}

export interface IHrecLoadFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IHrecLoadFailureAction;
}

export interface IHrecLoadByIdAction {
    type: "ACTION_HRECS_LOAD_BY_ID";
    id: number;
}

export interface IHrecLoadByIdActionCreator {
    (id: number): IHrecLoadByIdAction;
}

export interface IHrecSaveAction {
    type: "ACTION_HRECS_SAVE";
    formData: Dtos.Hrec;

}

export interface IHrecSaveActionCreator {
    (
        formData: Dtos.Hrec
    ): IHrecSaveAction;
}

export interface IHrecSaveSuccessAction {
    type: "ACTION_HRECS_SAVE_SUCCESS";
    formData: Dtos.Hrec;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IHrecSaveSuccessActionCreator {
    (
        formData: Dtos.Hrec,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IHrecSaveSuccessAction;
}

export interface IHrecSaveFailureAction {
    type: "ACTION_HRECS_SAVE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IHrecSaveFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IHrecSaveFailureAction;
}

export interface IHrecCreateAction {
    type: "ACTION_HRECS_CREATE"
}

export interface IHrecCreateActionCreator {
    (): IHrecCreateAction
}

export interface IHrecCreateSuccessAction {
    type: "ACTION_HRECS_CREATE_SUCCESS";
    formData: Dtos.Hrec;
    formState: Dtos.FormState,
    formProperties: Dtos.FormProperty[],
    lookups: Dtos.Lookup[]
}

export interface IHrecCreateSuccessActionCreator {
    (
        formData: Dtos.Hrec,
        formState: Dtos.FormState,
        formProperties: Dtos.FormProperty[],
        lookups: Dtos.Lookup[]
    ): IHrecCreateSuccessAction;
}

export interface IHrecCreateFailureAction {
    type: "ACTION_HRECS_CREATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IHrecCreateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IHrecCreateFailureAction;
}

export interface IHrecValidateAction {
    type: "ACTION_HRECS_VALIDATE";
    formData: Dtos.Hrec;

}

export interface IHrecValidateActionCreator {
    (
        formData: Dtos.Hrec
    ): IHrecValidateAction;
}

export interface IHrecValidateSuccessAction {
    type: "ACTION_HRECS_VALIDATE_SUCCESS";
    formData: Dtos.Hrec;
    formState: Dtos.FormState,
    responseStatus: Dtos.ResponseStatus;
}

export interface IHrecValidateSuccessActionCreator {
    (
        formData: Dtos.Hrec,
        formState: Dtos.FormState,
        responseStatus: Dtos.ResponseStatus
    ): IHrecValidateSuccessAction;
}

export interface IHrecValidateFailureAction {
    type: "ACTION_HRECS_VALIDATE_FAILURE";
    responseStatus: Dtos.ResponseStatus
}

export interface IHrecValidateFailureActionCreator {
    (responseStatus: Dtos.ResponseStatus): IHrecValidateFailureAction;
}

export interface IHrecClearAction {
    type: "ACTION_HRECS_CLEAR";
    propertiesToClear?: string[];
}

export interface IHrecClearActionCreator {
    (propertiesToClear?: string[]): IHrecClearAction;
}

export interface IHrecFilterActionCreator {
    (formFilter: IFormFilter): IHrecFilterAction;
}

export interface IHrecFilterAction {
    type: "ACTION_HRECS_FILTER";
    formFilter: IFormFilter;
}

export type HrecAction =
    IHrecLoadAction |
    IHrecLoadByIdAction |
    IHrecLoadFailureAction |
    IHrecLoadSuccessAction |
    IHrecSaveAction |
    IHrecSaveSuccessAction |
    IHrecSaveFailureAction |
    IHrecCreateAction |
    IHrecCreateSuccessAction |
    IHrecCreateFailureAction |
    IHrecValidateAction |
    IHrecValidateSuccessAction |
    IHrecValidateFailureAction |
    IHrecClearAction |
    IHrecFilterAction;
